import React from "react";
import Opener from "../opener/Opener";
import Header from "../menu/Header";
import { Link } from "react-router-dom";
import PDF from "../../assets/Nesrine_Mrabet_Resume_2023.pdf";

export default function Home() {
  return (
    <div style={{ height: "100vh" }}>
      <div className="Home">
        <Header />
        <div className="intro main-grid">
          <Opener />
          <h2 className="intro-text">Front-end developer + Copywriter</h2>
          <div className="btn-container">
            <a href={PDF} without rel="noopener noreferrer" target="_blank">
              <button
                trailingIcon="picture_as_pdf"
                label="Resume"
                className="btn focus:outline-none"
              >
                View Resume
              </button>
            </a>
            <Link to="/about">
              <button className="btn focus:outline-none mt-4 md:ml-4 md:mt-0">
                Know Me Better
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
